<template>
    <div class="card-text d-flex mt-2">
        <div class="w-50 pr-3">
            <b-card header="Notas" header-tag="header">
                <div class="card-text d-flex flex-column">
                    <div v-if="!data.item.notes.length" class="alert alert-info">No hay notas</div>
                    <div v-else v-for="note in data.item.notes">
                        <app-task-note-card :note="note" />
                    </div>
                </div>
            </b-card>
        </div>
        <div class="w-50 pr-3">
            <b-card header="Archivos" header-tag="header">
                <div class="card-text d-flex flex-column">
                    <div v-if="!data.item.files.length" class="alert alert-info">No hay archivos</div>
                    <div v-else v-for="(file, i) in data.item.files">
                        <app-task-file-card :file="file" />
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import TaskNoteCard from '../../UI/Tasks/TaskNoteCard.vue';
import TaskFileCard from '../../UI/Tasks/TaskFileCard.vue';
export default {
    components: {
        appTaskNoteCard: TaskNoteCard,
        appTaskFileCard: TaskFileCard
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    }
}
</script>